import { useEffect } from "react";
import { MANAGE_PAGE_SEARCH_DEBOUNCE_MS } from "../utils/managePageConstants";

/**
 * Runs callback after delay when deps change (grid fetch debounce).
 */
export default function useDebouncedEffect(
  callback,
  deps,
  delay = MANAGE_PAGE_SEARCH_DEBOUNCE_MS
) {
  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
}
